<template>
  <div
    v-if="related.length > 0 && (isFashionFix || !props.setsOnly)"
    class="related-products"
  >
    <h4>
      {{ isFashionFix ? "Other pieces in this set" : "You might also like" }}
    </h4>
    <div v-if="props.extended && isFashionFix" class="sets-text">
      <p>
        This look features pieces hand-selected by our Paparazzi stylists. Each
        set has been paired together by coordinating textures, colors, and other
        design elements to create a flawless cohesive look! Take the guesswork
        out of accessorizing and add all of these coordinating pieces to your
        bag now!
      </p>
    </div>

    <div class="product-list">
      <RouterLink
        v-for="mini of related.slice(0, count)"
        :to="{ name: 'product-detail', params: { slug: mini.slug } }"
        class="mini"
      >
        <ThumbnailedImage
          v-if="mini.images?.length > 0"
          :images="mini.images[0]"
          size="167"
          :alt="mini.name"
        />
        <span class="mini-name">{{ mini.name }}</span>
      </RouterLink>
    </div>
    <div v-if="props.extended && isFashionFix" class="sets-button">
      <RouterLink :to="{}">
        <Button class="p-button">Add Collection to Bag</Button>
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Product } from "@/stores/defs/shop_defs";
import { useShopStore } from "@/stores/shop";
import Button from "primevue/button";
import { computed, onMounted, ref, watch, type Ref } from "vue";
import ThumbnailedImage from "../ThumbnailedImage.vue";
import { loadRelated } from "./product_utils";

const props = withDefaults(
  defineProps<{
    object: Product;
    count?: number;
    setsOnly?: boolean;
    extended?: boolean;
  }>(),
  {
    count: 6,
    setsOnly: false,
    showDescription: false,
    extended: false,
  },
);

const related: Ref<Product[]> = ref([]);

const shop = useShopStore();

const categories = computed(() => {
  return shop.categories.filter((category) => {
    return (props.object.categories || []).includes(category.id);
  });
});
const isFashionFix = computed(() => {
  return categories.value.some((c) => /fashion fix/gi.test(c.name));
});

watch(
  () => props.object?.slug,
  async () => {
    if (props.object) {
      related.value = await loadRelated(props.object);
    }
  },
);

onMounted(async () => {
  if (props.object) {
    related.value = await loadRelated(props.object);
  }
});
</script>

<style lang="scss" scoped>
.related-products {
  padding-top: var(--Sm);
  padding-bottom: 8px;
  background: var(--10, #ededed);
}
.related-products h4 {
  color: var(--Black, #000);
  margin-top: 0;
  margin-bottom: var(--Sm);
  letter-spacing: 0.25px;

  /* Heading 4 */
  font-family: Indivisible;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  text-transform: uppercase;
  text-align: center;
}
.related-products > * {
  padding-inline: var(--Sm);
  justify-content: center;
  gap: var(--Sm);
}
.sets-text {
  max-width: 738px;
  margin: 0 auto var(--Sm, 24px);
  font-size: 12px;
  line-height: normal;
}
.sets-button {
  margin: var(--Sm, 24px) auto 0;
  text-align: center;
}
.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0px, auto));
  grid-template-rows: auto;
  justify-content: center;
  align-items: stretch;
  flex-direction: row;
  overflow: hidden;
  // border: 1px solid red;
  width: 100%;
  padding-bottom: 16px;
  gap: var(--Sm);
}
.mini {
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  min-width: 10px;
  // width: var(--Component-sizes-XS, 167px);
  width: 100%;
  max-width: 100%;
  // max-width: min-content;
  // border: 1px solid orangered;
  overflow: hidden;
}
.mini img {
  width: 167px;
  min-width: 0px;
  max-width: 100%;
  object-fit: cover;
  object-position: center;
  // height: 209px;
  margin-bottom: var(--2XS, 8px);
  aspect-ratio: 8 / 10;
}
@media (max-width: 800px) {
  #app .product-list {
    display: flex;
    justify-content: flex-start;
    overflow: auto;
  }
  #app .mini {
    flex: 0 0 auto;
    width: 167px;
  }
}

span.mini-name {
  color: var(--Black, #000);
  text-align: center;
  font-family: Indivisible;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: block;
  // display: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 90%;
}
</style>
